"use client";
import { jsxs as i, jsx as t } from "react/jsx-runtime";
import y from "../../../layout/Container/Container.js";
import { Box as N, Image as d, Group as a, Heading as m, Link as h, Icon as g, Paragraph as f, Button as p } from "@ingeniorforeningen/figurine-core";
import { forwardRef as w } from "react";
import '../../../../assets/HeroSimple.css';const v = "_content_iibb9_2", B = "_contentContainer_iibb9_24", k = "_title_iibb9_29", C = "_contentBottom_iibb9_33", H = "_cta_iibb9_37", n = {
  content: v,
  contentContainer: B,
  title: k,
  contentBottom: C,
  cta: H
}, _ = w((r, b) => {
  const { image: c, heading: l, description: s, editLink: o, style: x, ...u } = r, { link: e } = r;
  return /* @__PURE__ */ i(y, { ...u, ref: b, size: "xl", m: 0, children: [
    /* @__PURE__ */ i(N, { hiddenFrom: "sm", children: [
      /* @__PURE__ */ t(
        d,
        {
          ...c,
          caption: void 0,
          byline: void 0,
          orientation: "landscape",
          width: "edge",
          height: "19.6875em",
          children: /* @__PURE__ */ i(a, { className: n.content, style: x, children: [
            /* @__PURE__ */ t(
              m,
              {
                text: l,
                type: "display",
                variant: "light",
                align: "left",
                className: n.title
              }
            ),
            o && /* @__PURE__ */ t(h, { href: o, target: "_blank", children: /* @__PURE__ */ t(g, { name: "Edit", size: "xl", color: "light" }) })
          ] })
        }
      ),
      /* @__PURE__ */ i(a, { className: n.contentContainer, children: [
        /* @__PURE__ */ t(f, { text: s, align: "left" }),
        e && /* @__PURE__ */ t(
          p,
          {
            text: e.text,
            href: e.href,
            target: e.target,
            variant: "cta",
            className: n.cta,
            icon: "ArrowRight"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ t(
      d,
      {
        ...c,
        caption: void 0,
        byline: void 0,
        orientation: "landscape",
        width: "edge",
        height: "40.75em",
        visibleFrom: "sm",
        children: /* @__PURE__ */ i(
          a,
          {
            className: n.content,
            direction: "column",
            justify: "center",
            wrap: "nowrap",
            children: [
              /* @__PURE__ */ i(a, { spacing: "md", align: "center", children: [
                /* @__PURE__ */ t(
                  m,
                  {
                    text: l,
                    type: "display",
                    variant: "light",
                    align: "left",
                    className: n.title
                  }
                ),
                o && /* @__PURE__ */ t(h, { href: o, target: "_blank", children: /* @__PURE__ */ t(g, { name: "Edit", size: "xl", color: "light" }) })
              ] }),
              /* @__PURE__ */ i(a, { className: n.contentBottom, direction: "column", children: [
                /* @__PURE__ */ t(f, { text: s, variant: "light", align: "left" }),
                e && /* @__PURE__ */ t(
                  p,
                  {
                    text: e.text,
                    href: e.href,
                    target: e.target,
                    variant: "cta",
                    className: n.cta,
                    icon: "ArrowRight"
                  }
                )
              ] })
            ]
          }
        )
      }
    )
  ] });
});
_.displayName = "HeroSimple";
const A = _;
export {
  _ as _HeroSimple,
  A as default
};
